<template>
  <div>
    <input
        style="display: none;"
        ref="input"
        type="file"
        :accept="accept"
        @change="onChange"
    />
    <v-btn
        :width="width"
        :height="height"
        :disabled="disabled"
        outlined
        @click="onClick"
    >
      <slot/>
    </v-btn>
  </div>
</template>

<script>
import ComponentMixin from "@/components/ComponentMixin";

export default {
  mixins: [ComponentMixin],
  type: "atom",
  name: "FileSelectButton",
  props: {
    image: {
      type: Boolean,
    },
    maxSize: {
      type: Number,
    },
    width: {
      type: String
    },
    height: {
      type: String
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    accept () {
      if (this.image) {
        return "image/jpeg,image/png";
      }
      return null;
    }
  },
  methods: {
    onClick() {
      const input = this.$refs.input
      input.value = input.defaultValue;
      input.click();
    },
    onChange() {
      const file = this.$refs.input.files[0];
      if (!!file && this.maxSize && file.size > this.maxSize) {
        const message = this.error("maxSize", [this.sizeToText(this.maxSize)]);
        this.$emit("error", file, message);
        return;
      }
      this.$emit("input", file);
    }
  }
}
</script>

<style scoped>

</style>